import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import axios from 'axios';

interface StarRatingProps {
  reviewCount?: number;
  point?: number;
  business_id: number;
  stype?: 'style1' | 'style2'; // New optional prop for styles
}

interface RatingResponse {
  totalRatings?: number;
  RatingCount?: number;
}

const StarRating: React.FC<StarRatingProps> = ({ reviewCount = 0, point = 0, business_id, stype = 'style1' }) => {
  const [rating, setRating] = useState<number>(point);
  const [totalReviews, setTotalReviews] = useState<number>(reviewCount);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (point === 0 && reviewCount === 0) {
      setLoading(true);
      axios.post<RatingResponse>('/api/business/google/review', {
        business_id,
        page: 1,
        reviewsPerPage: 1,
      })
      .then(response => {
        if (response.data) {
          setRating(response.data.totalRatings ?? 0);
          setTotalReviews(response.data.RatingCount ?? 0);
        }
      })
      .catch(error => console.error('Error fetching ratings:', error))
      .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [business_id, point, reviewCount]);

  if (loading) {
    return (
      <div className="animate-pulse flex space-x-1">
        {[...Array(5)].map((_, index) => (
          <FaStar key={index} className="w-4 h-4 text-gray-200" />
        ))}
      </div>
    );
  }

  if (stype === 'style2') {
    return (
      <div className="flex items-center space-x-2">
        <FaStar className="w-5 h-5 text-yellow-400" />
        <span className="text-lg font-semibold text-gray-700">{rating}</span>
        <span className="text-sm text-gray-500">(Google Rating)</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <div className="flex space-x-1">
        {[...Array(5)].map((_, index) => (
          <FaStar
            key={index}
            className={`w-4 h-4 ${index < Math.round(rating) ? 'text-black' : 'text-gray-300'}`}
          />
        ))}
      </div>
      {totalReviews > 0 && (
        <span className="text-sm text-gray-600">
          ({totalReviews} {totalReviews === 1 ? 'review' : 'reviews'})
        </span>
      )}
    </div>
  );
};

export default StarRating;
